<spinner
  [center]="true"
  size="la-2x"
  color="grey"
  type="ball-triangle-path"
></spinner>

<div class="dialog-header">
  <div class="dialog-title">
    <div class="logo-container">
      <img [src]="data.box.logo" width="24px" height="24px" alt="App Logo"/>
      <span>{{ data.appObjName }} {{ displayNameObj.app.objDisplayName | titlecase }} Creator</span>
    </div>
  </div>
  <p class="dialog-description">
    Create a new {{ displayNameObj.app.objDisplayName | titlecase }} in {{ data.appObjName }} having same fields as in your chosen {{ data.sourceObjName }} module in Zoho.
  </p>

  <div class="spacer"></div>

  <mat-form-field appearance="outline">
    <mat-label>{{displayNameObj.app.objDisplayName | titlecase}} Name</mat-label>
    <input matInput 
      (input)="onChangeOfObjectName($event.target.value)" 
      [(ngModel)]="objectName"
      placeholder="Enter name here" 
    />
    <mat-hint>Please provide a unique name for this {{displayNameObj.app.objDisplayName | titlecase}}</mat-hint>
    <mat-error *ngIf="!objectName.length">{{ (displayNameObj.app.objDisplayName | titlecase) + "is empty" }}</mat-error>
  </mat-form-field>
</div>

<div class="spacer"></div>

<div mat-dialog-content>
  <section class="dialog-container mat-elevation-z8" tabindex="0"> 
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox color="primary" 
                       (change)="$event ? toggleAllRows() : null"
                       [checked]="selection.hasValue() && isAllSelected()"
                       [indeterminate]="selection.hasValue() && !isAllSelected()"
                       [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox color="primary" 
                       (click)="$event.stopPropagation()"
                       (change)="$event ? selection.toggle(row) : null"
                       [checked]="selection.isSelected(row)"
                       [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>
    
      <!-- Type Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let element">
          <div class="type-container">
            <mat-icon class="type-icon">{{ MappingIcons.appFieldIconMap[element.type.toLowerCase()] || 'help_outline' }}</mat-icon>
            <span>{{element.type}}</span>
          </div>
        </td>
      </ng-container>
    
      <!-- Zoho Attribute Name Column -->
      <ng-container matColumnDef="zoho_attr_name">
        <th mat-header-cell *matHeaderCellDef>
          <div class="logo-container">
            <img [src]="data.displayNameObj?.source?.logo" width="20px" height="20px" alt="Source Logo"/>  
            <span>{{ data.sourceObjName }} {{ displayNameObj.source.attrDisplayName | titlecase }} Name</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <span>{{element.zoho_attr_name}}</span>
        </td>
      </ng-container>
    
      <!-- App Attribute Name Column -->
      <ng-container matColumnDef="app_attr_name">
        <th mat-header-cell *matHeaderCellDef>
          <div class="logo-container">
            <img [src]="data.displayNameObj?.app?.logo" width="20px" height="20px" alt="App Logo"/>  
            <span>{{data.appObjName }} {{ displayNameObj.app.attrDisplayName | titlecase }} Name</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="editable-cell" (mouseenter)="showEditIcon(element)" (mouseleave)="hideEditIcon(element)">
            <div class="display-mode" *ngIf="!element.isEditingApp">
              <span>{{element.app_attr_name}}</span>
              <mat-icon class="edit-icon" (click)="startEditing(element)">edit</mat-icon>
            </div>
            <div class="edit-mode" *ngIf="element.isEditingApp">
              <input matInput 
                     [value]="element.app_attr_name"
                     (input)="onNameInput($event, element)"
                     (keyup.enter)="confirmEdit(element)"
                     #appInput>
              <mat-icon class="confirm-icon" (click)="confirmEdit(element)">check</mat-icon>
            </div>
          </div>
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;">
      </tr>
    </table>
  </section>
</div>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
  <div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="start center">
    <div class="status-message" *ngIf="statusMessage" [ngClass]="isError ? 'warning' : 'success'">
      <mat-icon>{{ isError ? 'error_outline' : 'check_circle' }}</mat-icon>
      <span>{{ statusMessage }}</span>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="end center">
    <button mat-raised-button 
            *ngIf="!canContinueEnabled" 
            color="primary" 
            cdkFocusInitial
            (click)="createObject()"
            [disabled]="isLoading || !objectName.length">
      <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
      <span *ngIf="!isLoading">Create {{displayNameObj.app.objDisplayName | titlecase}} Now</span>
    </button>
    <button mat-raised-button 
            *ngIf="canContinueEnabled" 
            color="primary" 
            cdkFocusInitial 
            (click)="createAnother()"
            [disabled]="isLoading">
      <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
      <span *ngIf="!isLoading">Create another {{displayNameObj.app.objDisplayName | titlecase}}</span>
    </button>
    <button mat-button 
            mat-dialog-close
            *ngIf="!canContinueEnabled">
      Cancel
    </button>
    <button mat-raised-button 
            *ngIf="canContinueEnabled"
            [mat-dialog-close]="objResponse" 
            color="primary">
      Continue
    </button>
  </div>
</div>